import _ from "lodash";
import { FILE, documentAlreadyUploaded } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import BalanceDocumentsMixin from "@/mixins/BalanceDocumentsMixin";
import OtherDocumentsMixin from "@/mixins/OtherDocumentsMixin";

export default {
  mixins: [DocumentsMixin, BalanceDocumentsMixin, OtherDocumentsMixin],
  methods: {
    onCompletedBalanceDocumentSelection(docs) {
      this.onSelectedBalanceDocuments(docs);
      this.isBalanceModalOpen = false;
    },
    onCompletedDocumentSelection(doc) {
      this.onSelectedDocument(doc);
      this.documentModalForKey = null;
    },
    submitBalanceDocuments({ documents }) {
      const { uploadDocument } = this;
      const [alreadyUploaded, needsUpload] = _.partition(documents, doc =>
        documentAlreadyUploaded(doc)
      );
      return needsUpload.length == 0
        ? Promise.resolve(alreadyUploaded)
        : Promise.all(
            _.map(needsUpload, ({ arquivo, ...info }) =>
              uploadDocument(arquivo[FILE], (file, arquivo) => ({
                ...info,
                arquivo
              }))
            )
          ).then(balancos => [...alreadyUploaded, ...balancos]);
    },
    submitOtherDocuments(otherDocuments) {
      const { uploadDocument } = this;
      let uploadOthersDocuments = Object.values(
        _.cloneDeep(otherDocuments)
      ).flat();
      return Promise.all(
        _.map(uploadOthersDocuments, document =>
          documentAlreadyUploaded(document)
            ? Promise.resolve(document)
            : uploadDocument(document.arquivo[FILE], (file, arquivo) => ({
                tipo_documento: document.tipo_documento,
                arquivo
              }))
        )
      );
    },
    submitDocuments(balanceDocuments, otherDocuments) {
      return this.submitBalanceDocuments(balanceDocuments).then(balancos =>
        this.submitOtherDocuments(otherDocuments).then(documentos => ({
          balancos,
          documentos
        }))
      );
    }
  }
};
